import { api, endpoints } from "../api";
import { AxiosPromise } from "axios";

export const TRAINER_FILE_UPLOADED_BY = {
  TRAINER: 1,
  ADMIN: 2,
} as const;
export type TrainerFileUploadedByTypeApi =
  (typeof TRAINER_FILE_UPLOADED_BY)[keyof typeof TRAINER_FILE_UPLOADED_BY];

export const TRAINER_FILE_STATUS = {
  PENDING_REVIEW: 1,
  PAID: 2,
  REJECTED: 3,
} as const;
export type TrainerFileStatusApi =
  (typeof TRAINER_FILE_STATUS)[keyof typeof TRAINER_FILE_STATUS];

export interface TrainerFileApi {
  id: number;
  uploadedByType: TrainerFileUploadedByTypeApi;
  uploaderName: string;
  originalFileName: string;
  contentType: string;
  sizeBytes: number;
  note?: string;
  status?: TrainerFileStatusApi;
  commentCount: number;
  createdDate: string;
}

export interface TrainerFileCommentApi {
  id: number;
  authorType: TrainerFileUploadedByTypeApi;
  authorName: string;
  body: string;
  createdDate: string;
}

const fetchFiles = (trainerId: number): AxiosPromise<TrainerFileApi[]> => {
  return api.get<TrainerFileApi[]>(endpoints.TRAINERS.GET_FILES(trainerId));
};

const uploadFile = (trainerId: number, file: File, note?: string) => {
  const formData = new FormData();
  formData.append("File", file);
  if (note) formData.append("Note", note);
  return api.post(endpoints.TRAINERS.CREATE_FILE(trainerId), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

const setStatus = (trainerId: number, fileId: number, status: TrainerFileStatusApi) => {
  return api.patch(endpoints.TRAINERS.SET_FILE_STATUS(trainerId, fileId), { status });
};

const downloadFile = (trainerId: number, fileId: number) => {
  return api.get(endpoints.TRAINERS.DOWNLOAD_FILE(trainerId, fileId), {
    responseType: "blob",
  });
};

export interface TrainerFilePreviewUrlApi {
  url: string;
  contentType: string;
}

const getPreviewUrl = (trainerId: number, fileId: number): AxiosPromise<TrainerFilePreviewUrlApi> => {
  return api.get<TrainerFilePreviewUrlApi>(
    endpoints.TRAINERS.GET_FILE_PREVIEW_URL(trainerId, fileId),
  );
};

const deleteFile = (trainerId: number, fileId: number) => {
  return api.delete(endpoints.TRAINERS.DELETE_FILE(trainerId, fileId));
};

const fetchComments = (
  trainerId: number,
  fileId: number,
): AxiosPromise<TrainerFileCommentApi[]> => {
  return api.get<TrainerFileCommentApi[]>(endpoints.TRAINERS.GET_FILE_COMMENTS(trainerId, fileId));
};

const addComment = (trainerId: number, fileId: number, body: string) => {
  return api.post(endpoints.TRAINERS.GET_FILE_COMMENTS(trainerId, fileId), { body });
};

export const trainerFilesApi = {
  fetchFiles,
  uploadFile,
  setStatus,
  downloadFile,
  getPreviewUrl,
  deleteFile,
  fetchComments,
  addComment,
};
